import { ChevronDownIcon } from 'lucide-react';
import { type DropdownIndicatorProps, components } from 'react-select';
import type { CountryOption } from './types';

export const VisitorDropDownIndicator: React.FC<DropdownIndicatorProps<CountryOption, false>> = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDownIcon className="w-4 h-4 text-gray-400" />
    </components.DropdownIndicator>
  );
};
